import http from '@libs/http';
import {
  InitialPublicOffer,
  CreateInitialPublicOffer,
  UpdateInitialPublicOffer,
  CreatePreInitialPublicOffer,
} from '@libs/api-reference';

import { TSE_API } from './endpoints';

export function getInitialPublicOffers() {
  return http.get(`${TSE_API}/initialpublicoffers/instruments`, {
    schema: InitialPublicOffer,
  });
}

export function createInitialPublicOffer(data: CreateInitialPublicOffer) {
  return http.post(`${TSE_API}/initialpublicofferorders`, data);
}

export function updateInitialPublicOffer(data: UpdateInitialPublicOffer) {
  return http.put(`${TSE_API}/initialpublicofferorders`, data);
}

export function deleteInitialPublicOffer(orderId: number) {
  return http.delete(`${TSE_API}/initialpublicofferorders/{orderId}`, {
    urlParams: { orderId },
  });
}

export function createPreInitialPublicOffer(data: CreatePreInitialPublicOffer) {
  return http.post(
    `${TSE_API}/initialpublicoffers/{instrumentIsin}/preorders`,
    {
      quantity: data.quantity,
      price: data.price,
      orderExecutionType: data.orderExecutionType,
    },
    {
      urlParams: { instrumentIsin: data.instrumentIsin },
    }
  );
}

export function deletePreInitialPublicOffer(id: string) {
  return http.delete(`${TSE_API}/initialpublicoffers/{id}/preorders`, {
    urlParams: { id },
  });
}
